(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-reels"] && !Shopify.designMode) return;
  try {
    
  class TiktokReels extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tl-reels__track');
      this.videos = Array.from(this.querySelectorAll('.tl-reels__video'));
      this.slides = Array.from(this.querySelectorAll('.tl-reels__slide'));
      this.dots = Array.from(this.querySelectorAll('.tl-reels__dots i'));
      this.soundBtn = this.querySelector('.tl-reels__sound');
      // We WANT sound on by default; browsers may block unmuted autoplay until a
      // user gesture, in which case we fall back to muted and unmute on first input.
      this.soundOn = true;
      this.active = 0;
      this.gestureArmed = false;
      this.resume = this.resume.bind(this);

      if (this.soundBtn) {
        this.soundBtn.addEventListener('click', this.toggleSound.bind(this));
      }

      this.io = new IntersectionObserver(this.onIntersect.bind(this), {
        root: this.track,
        threshold: 0.6,
      });
      this.slides.forEach((slide) => this.io.observe(slide));

      // Only play while at least 50% of the phone is visible in the viewport.
      this.phone = this.querySelector('.tl-reels__phone');
      this.onScreen = false;
      this.vio = new IntersectionObserver(this.onViewport.bind(this), {
        threshold: [0, 0.5, 1],
      });
      if (this.phone) this.vio.observe(this.phone);
    }

    onViewport(entries) {
      entries.forEach((entry) => {
        this.onScreen = entry.isIntersecting && entry.intersectionRatio >= 0.5;
        if (this.onScreen) {
          this.playOnly(this.active);
        } else {
          this.videos.forEach((video) => video.pause());
        }
      });
    }

    onIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const idx = this.slides.indexOf(entry.target);
        if (idx < 0) return;
        this.active = idx;
        this.playOnly(idx);
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
      });
    }

    reflect() {
      if (!this.soundBtn) return;
      this.soundBtn.classList.toggle('is-on', this.soundOn);
      this.soundBtn.setAttribute('aria-pressed', String(this.soundOn));
    }

    playOnly(idx) {
      this.videos.forEach((video, i) => {
        if (i !== idx) {
          video.pause();
          video.muted = true;
          return;
        }
        if (!this.onScreen) {
          video.pause();
          return;
        }
        video.muted = !this.soundOn;
        const p = video.play();
        if (p && p.catch) {
          p.catch(() => {
            // Unmuted autoplay was blocked: play muted now, unmute on first gesture.
            this.soundOn = false;
            video.muted = true;
            this.reflect();
            const p2 = video.play();
            if (p2 && p2.catch) p2.catch(() => {});
            this.armGesture();
          });
        }
      });
      this.reflect();
    }

    armGesture() {
      if (this.gestureArmed) return;
      this.gestureArmed = true;
      ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach((ev) =>
        document.addEventListener(ev, this.resume, { capture: true, passive: true })
      );
    }

    resume() {
      ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach((ev) =>
        document.removeEventListener(ev, this.resume, { capture: true })
      );
      this.gestureArmed = false;
      this.soundOn = true;
      const video = this.videos[this.active];
      if (video) {
        video.muted = false;
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      }
      this.reflect();
    }

    toggleSound() {
      this.soundOn = !this.soundOn;
      const video = this.videos[this.active];
      if (video) {
        video.muted = !this.soundOn;
        if (this.soundOn) {
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
      }
      this.reflect();
    }
  }

  if (!customElements.get('tiktok-reels')) {
    customElements.define('tiktok-reels', TiktokReels);
  }

  } catch(e) { console.error(e); }
})();
})();
